import i18n from '@/i18n'

/**
 * 字典项/分类的最小结构子类型，只需 name 和可选 nameEn。
 * 兼容 SysDictionaryItem、SysDictionary 及其他派生对象。
 */
interface DictLabelLike {
  name: string
  nameEn?: string
}

/**
 * 按当前 locale 返回字典项标签。
 * 英文模式下优先返回 nameEn；nameEn 为空时兜底返回 name（中文）。
 */
export function dictItemLabel(item: DictLabelLike | undefined | null): string {
  if (!item) return ''
  const locale = i18n.global.locale.value
  if (locale === 'en' && item.nameEn) {
    return item.nameEn
  }
  return item.name
}

/**
 * 按当前 locale 返回字典分类名称。
 */
export function dictCategoryLabel(dict: DictLabelLike | undefined | null): string {
  if (!dict) return ''
  const locale = i18n.global.locale.value
  if (locale === 'en' && dict.nameEn) {
    return dict.nameEn
  }
  return dict.name
}

/**
 * 按当前 locale 返回字典分类描述。
 */
export function dictCategoryDescription(dict: { description?: string; descriptionEn?: string } | undefined | null): string {
  if (!dict) return ''
  const locale = i18n.global.locale.value
  if (locale === 'en' && dict.descriptionEn) {
    return dict.descriptionEn
  }
  return dict.description || ''
}
